import { EdgesGeometry, Mesh, MeshBasicMaterial, PolyhedronGeometry, Vector2 } from 'three';

import { LineMaterial, LineSegmentsGeometry, LineSegmentsMesh } from '@/lib/three';
import { WidgetObject } from '@/types';

export interface Pyramid3dOptions {
  color: string;
  canvasSize?: number[];
}
const DEFAULT_OPACITY = 0.4;
const PYRAMID_SCALE = 0.5;

export class Pyramid3d {
  static vertices = [0, 0, 0, 1, -0.6, 3, 0, 1.2, 3, -1, -0.6, 3];
  static indices = [2, 1, 0, 0, 3, 2, 1, 3, 0, 2, 3, 1];

  static create(data: WidgetObject['data'], options: Pyramid3dOptions): Mesh<PolyhedronGeometry, MeshBasicMaterial> {
    const { color, canvasSize = [1000, 1000] } = options;
    const geometry = new PolyhedronGeometry(Pyramid3d.vertices, Pyramid3d.indices, 3, 0);
    const material = new MeshBasicMaterial({ color, opacity: DEFAULT_OPACITY, transparent: true });

    const pyramid = new Mesh(geometry, material);
    pyramid.position.fromArray(data);
    pyramid.scale.set(PYRAMID_SCALE, PYRAMID_SCALE, PYRAMID_SCALE);

    const borderGeometry = new LineSegmentsGeometry();
    borderGeometry.fromEdgesGeometry(new EdgesGeometry(geometry));
    const border = new LineSegmentsMesh(
      borderGeometry,
      new LineMaterial({
        linewidth: 1,
        color,
        resolution: new Vector2(...canvasSize),
      })
    );

    pyramid.add(border);

    pyramid.name = pyramid.uuid;
    pyramid.userData = { type: 'pyramid', ...options };

    return pyramid;
  }

  static createFromComment(name: string, position: number[], options: Pyramid3dOptions) {
    const pyramid = Pyramid3d.create(position, options);
    pyramid.name = name;
    return pyramid;
  }

  static changeColor(target: Mesh<PolyhedronGeometry, MeshBasicMaterial>, color: string, refreshData = true) {
    const material = target.material as MeshBasicMaterial;
    material.color.set(color);

    for (let i = 0, l = target.children.length; i < l; i++) {
      const obj = target.children[i];
      if (obj instanceof LineSegmentsMesh && 'color' in obj.material) {
        obj.material.color.set(color);
      }
    }

    if (refreshData) {
      target.userData.color = color;
    }
  }
}
